import { ChangeEvent } from "react";
import styled from "styled-components";

interface TextAreaProps {
  name: string;
  value: string;
  placeholder: string;
  label: string;
  cols: number;
  rows: number;
  handleChange: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
}

const TextArea = ({
  name,
  value,
  placeholder,
  label,
  cols,
  rows,
  handleChange,
}: TextAreaProps) => {
  return (
    <TextAreaWrapper className="job__desc__con">
      <p>{label}</p>
      <textarea
        name={name}
        value={value}
        placeholder={placeholder}
        cols={cols}
        rows={rows}
        onChange={handleChange}
      ></textarea>
    </TextAreaWrapper>
  );
};

export default TextArea;

const TextAreaWrapper = styled.div`
  textarea {
    font-size: 14px;
  }
  > textarea::placeholder {
    font-size: 14px;
    padding-block: 4px;
  }
`;
